import { TypedMutation } from "@saleor/mutations";
import gql from "graphql-tag";

import {
  ClusterBulkDelete,
  ClusterBulkDeleteVariables
} from "./types/ClusterBulkDelete";
import { ClusterCreate, ClusterCreateVariables } from "./types/ClusterCreate";
import { ClusterDelete, ClusterDeleteVariables } from "./types/ClusterDelete";
import { ClusterUpdate, ClusterUpdateVariables } from "./types/ClusterUpdate";

// import {
//   AnnouncementCreate,
//   AnnouncementCreateVariables
// } from "./types/AnnouncementCreate";
// import {
//   AnnouncementUpdate,
//   AnnouncementUpdateVariables
// } from "./types/AnnouncementUpdate";

const clusterCreate = gql`
  mutation ClusterCreate($input: ClusterCreateInput!) {
    clusterCreate(input: $input) {
      errors: clusterError {
        field
        message
        code
      }
      cluster {
        id
        name
        productType {
          id
          name
        }
      }
    }
  }
`;
export const TypedClusterCreate = TypedMutation<
  ClusterCreate,
  ClusterCreateVariables
>(clusterCreate);

const clusterUpdate = gql`
  mutation ClusterUpdate($id: ID!, $input: ClusterCreateInput!) {
    clusterUpdate(id: $id, input: $input) {
      errors: clusterError {
        field
        message
        code
      }
      cluster {
        id
        name
        productType {
          id
          name
        }
      }
    }
  }
`;
export const TypedClusterUpdate = TypedMutation<
  ClusterUpdate,
  ClusterUpdateVariables
>(clusterUpdate);

const clusterDelete = gql`
  mutation ClusterDelete($id: ID!) {
    clusterDelete(id: $id) {
      errors: clusterError {
        field
        message
      }
    }
  }
`;
export const TypedClusterDelete = TypedMutation<
  ClusterDelete,
  ClusterDeleteVariables
>(clusterDelete);

const clusterBulkDelete = gql`
  mutation ClusterBulkDelete($ids: [ID]!) {
    clusterBulkDelete(ids: $ids) {
      errors {
        field
        message
      }
    }
  }
`;
export const TypedClusterBulkDelete = TypedMutation<
  ClusterBulkDelete,
  ClusterBulkDeleteVariables
>(clusterBulkDelete);
